<template>
  <section class="block--banner">
    <h1 class="page__title main-title tc-custom-red text-center my0 py30-md py20">
      {{ title }}
    </h1>
  </section>
</template>

<script>
export default {
  props: {
    title: String
  }
};
</script>
